import { render, staticRenderFns } from "./BookmarkerPlugin.vue?vue&type=template&id=0a252f62&scoped=true"
import script from "./BookmarkerPlugin.vue?vue&type=script&lang=ts"
export * from "./BookmarkerPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./BookmarkerPlugin.vue?vue&type=style&index=0&id=0a252f62&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0a252f62",
  null
  ,true
)

export default component.exports